const withName = (component, name) => {
    const NamedComponent = (props) => props && component(props) || null;
    // uses a known name in the ErrorBoundary's componentStack
    NamedComponent.displayName = name;
    return NamedComponent;
};

export default withName;
